import PDFPage from '@/components/ReportPDF/PDFPage'
import { Text, View } from '@react-pdf/renderer'
import PDFCell from '../../PDFCell'
import PDFRow from '../../PDFRow'

const AttachmentPage = ({ reportData, setPage }) => {
  const { notYetFinishData, trainingListData } = reportData || {}

  const data1 = trainingListData || []
  const data2 = notYetFinishData || []

  return (
    <PDFPage reportData={reportData}>
      <View>
        <Text
          render={({ pageNumber }) => {
            setPage({ attach1: pageNumber })
          }}
        />

        <Text style={{ marginBottom: 40 }}>附件一 訓練名單</Text>

        <PDFRow>
          <PDFCell flex={1} style={{ fontWeight: 'bold' }}>
            <Text>姓名</Text>
          </PDFCell>
          <PDFCell flex={1} style={{ fontWeight: 'bold' }}>
            <Text>單位</Text>
          </PDFCell>
          <PDFCell flex={3} style={{ fontWeight: 'bold' }}>
            <Text>郵件</Text>
          </PDFCell>
        </PDFRow>

        {data1.map((d, index) => (
          <PDFRow key={`data1_${index + 1}`}>
            <PDFCell flex={1}>
              <Text>{d.userName || '-'}</Text>
            </PDFCell>
            <PDFCell flex={1}>
              <Text>{d.unit || '-'}</Text>
            </PDFCell>
            <PDFCell flex={3}>
              <Text>{d.email || '-'}</Text>
            </PDFCell>
          </PDFRow>
        ))}

        <Text
          render={({ pageNumber }) => {
            setPage({ attach2: pageNumber })
          }}
        />
        <Text style={{ marginTop: 80, marginBottom: 40 }}>附件二 未完成訓練名單</Text>

        <PDFRow>
          <PDFCell flex={1} style={{ fontWeight: 'bold' }}>
            <Text>姓名</Text>
          </PDFCell>
          <PDFCell flex={1} style={{ fontWeight: 'bold' }}>
            <Text>單位</Text>
          </PDFCell>
          <PDFCell flex={3} style={{ fontWeight: 'bold' }}>
            <Text>郵件</Text>
          </PDFCell>
        </PDFRow>

        {data2.map((d, index) => (
          <PDFRow key={`data2_${index + 1}`}>
            <PDFCell flex={1}>
              <Text>{d.userName || '-'}</Text>
            </PDFCell>
            <PDFCell flex={1}>
              <Text>{d.unit || '-'}</Text>
            </PDFCell>
            <PDFCell flex={3}>
              <Text>{d.email || '-'}</Text>
            </PDFCell>
          </PDFRow>
        ))}
      </View>
    </PDFPage>
  )
}

export default AttachmentPage
